export const itemViewCellStyles = { border: "none", padding: 0 };
export const itemViewDetailsContainerStyles = { padding: "var(--size-xl)" };
export const itemViewDetailsTableStyles = { padding: 0 };
export const itemViewListContainerStyles = {
    marginTop: "var(--size-xxl)",
    padding: "0 var(--size-xxl)",
};

export const itemViewListExtraTopPaddingStyles = {
    padding: "var(--size-s) 0 0 0"
};
export const itemViewSeparatorStyles = {
    height: "1px",
    borderBottom: "1px solid #B3B3B3",
    margin: "0 var(--size-m)",
};
export const itemViewSubtitleStyles = { margin: "0 0 var(--size-l) 0" };
export const itemXlPadding = { padding: "var(--size-xl)" }; 